import React, { Component } from "react";
import ConfirmButton from "./../../../../../buttons/ConfirmButton";

class AddSurvey extends Component {
	render() {
		return (
			<ConfirmButton
				label="Créer un questionnaire"
				large={true}
				path="/survey/creation"
			/>
		);
	}
}
export default AddSurvey;



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/AddSurvey/AddSurvey.js